import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { BrandCampaignPostsFilters } from "../../../../shared/services/filters/brand-campaign-post-filters";
import { BrandCampaignPostsFiltersOrderBy } from "../../../../shared/services/filters/brand-campaign-post-filters-order-by";
import { BrandCampaignPartnersService } from "../../shared/services/brand-campaign-partners.service";
import { BrandCampaignService } from "../../shared/services/brand-campaign.service";
import { PostsFiltersPartner } from "./posts-filters-partner";
import { removeDiacritics } from "../../../../shared/utils/remove-diacritics";

@Component({
  selector: "app-brand-campaign-posts-filters",
  templateUrl: "./brand-campaign-posts-filters.component.html",
  styleUrls: ["./brand-campaign-posts-filters.component.scss"],
})
export class BrandCampaignPostsFiltersComponent implements OnInit {
  @Output() public readonly filterPosts =
    new EventEmitter<BrandCampaignPostsFilters>();

  protected readonly LIMIT = 15;
  protected readonly OrderPostsBy = BrandCampaignPostsFiltersOrderBy;
  protected displayFacebookAds = true;
  protected displayFacebookPosts = true;
  protected displayGoogleAds = true;
  protected displayLinkedInPosts = true;
  protected isFiltered = false;
  protected loading = false;
  protected orderBy = BrandCampaignPostsFiltersOrderBy.Date;
  protected pageIndex = 0;
  protected partnersPage: PostsFiltersPartner[] = [];
  protected searchKey = "";
  protected showOrderBy = false;
  protected showPartnersFilters = false;
  protected showPostTypeFilters = false;
  protected totalPartners = 0;

  private partnersAll: PostsFiltersPartner[] = [];
  private partnersFiltered: PostsFiltersPartner[] = [];
  private offset = 0;

  constructor(
    private readonly brandCampaignService: BrandCampaignService,
    private readonly brandCampaignPartnersService: BrandCampaignPartnersService,
  ) {}

  public ngOnInit(): void {
    this.loadPartnerList();
  }

  private loadPartnerList(): void {
    const limit = 200;

    this.loading = true;

    this.brandCampaignPartnersService
      .getBrandCampaignPartners(
        this.brandCampaignService.currentBrandCampaignId,
        this.offset,
        limit,
      )
      .subscribe((list) => {
        this.totalPartners = list.totalCount;

        list.items.forEach((partner) => {
          this.partnersAll.push({
            id: partner.id,
            value: String(partner.id),
            checked: true,
            name: String(partner.companyName),
            search: (
              String(partner.companyName) +
              removeDiacritics(String(partner.companyName))
            ).toLowerCase(),
          });
        });

        this.loading = false;

        if (
          list.items.length > 0 &&
          list.totalCount > this.partnersAll.length
        ) {
          this.offset = this.offset + limit;
          this.loadPartnerList();
        } else {
          this.partnersAll.sort((a, b) => a.name.localeCompare(b.name));
          this.filterPartners("", 0);
          this.loading = false;
        }
      });
  }

  protected setOrderBy(orderBy: BrandCampaignPostsFiltersOrderBy): void {
    this.orderBy = orderBy;
    this.showOrderBy = false;
    this.calculateAndEmitFilters();
  }

  protected togglePartnerFilter(filterPartner: PostsFiltersPartner): void {
    filterPartner.checked = !filterPartner.checked;
    this.calculateAndEmitFilters();
  }

  protected toggleDisplayFacebookPosts(): void {
    this.displayFacebookPosts = !this.displayFacebookPosts;
    this.calculateAndEmitFilters();
  }

  protected toggleDisplayFacebookAds(): void {
    this.displayFacebookAds = !this.displayFacebookAds;
    this.calculateAndEmitFilters();
  }

  protected toggleDisplayGoogleAds(): void {
    this.displayGoogleAds = !this.displayGoogleAds;
    this.calculateAndEmitFilters();
  }

  protected toggleDisplayLinkedInPosts(): void {
    this.displayLinkedInPosts = !this.displayLinkedInPosts;
    this.calculateAndEmitFilters();
  }

  private calculateAndEmitFilters(): void {
    const selectedPartnerIds = this.partnersAll
      .filter((partner) => partner.checked)
      .map((partner) => partner.id);

    this.filterPosts.emit({
      partnerIds: selectedPartnerIds,
      facebookPosts: this.displayFacebookPosts,
      facebookAds: this.displayFacebookAds,
      googleAds: this.displayGoogleAds,
      linkedinPosts: this.displayLinkedInPosts,
      orderBy: this.orderBy,
    });
  }

  protected setAllPartnersFilteredChecked(checked: boolean): void {
    this.partnersFiltered.forEach((partner) => {
      partner.checked = checked;
    });

    this.calculateAndEmitFilters();
  }

  protected clearPartnersFilter(): void {
    this.searchKey = "";
    this.filterPartners(this.searchKey);
  }

  protected filterPartners(searchKey: string, pageIndex = 0): void {
    searchKey = searchKey.trim().toLowerCase();

    this.partnersFiltered = searchKey
      ? this.partnersAll.filter(({ search }) => search.includes(searchKey))
      : this.partnersAll;

    this.isFiltered = searchKey.length > 0;
    this.totalPartners = this.partnersFiltered.length;
    this.offset = this.LIMIT * pageIndex;
    this.pageIndex = pageIndex;
    this.partnersPage = this.partnersFiltered.slice(
      this.offset,
      this.offset + this.LIMIT,
    );
  }

  protected onPageChange(pageIndex: number) {
    this.filterPartners(this.searchKey, pageIndex);
  }
}
